import DeviceType from "./DeviceType.js";
import DeviceTypeId from "./DeviceTypeId.js";
import FirmwareApplicationId from "./FirmwareApplicationId.js";
import Id from "./Id.js";
import Metadata from "./Metadata.js";
import Name from "./Name.js";
import ProjectId from "./ProjectId.js";
import StartTime from "./StartTime.js";
import State from "./State.js";
import Type from "./Type.js";
import UpgradeOptions from "./UpgradeOptions.js";
import FirmwareApplication from "./FirmwareApplication.js";
import LoadBalancerEnabled from "./LoadBalancerEnabled.js";
import UpgradeWindowsEnabled from "./UpgradeWindowsEnabled.js";
import DeviceGroups from "./DeviceGroups.js";
import PercentToGetApplication from "./PercentToGetApplication.js";
export default {
  install: molten => {
    molten.addPlugin('Attribute', DeviceTypeId);
    molten.addPlugin('Attribute', DeviceType);
    molten.addPlugin('Attribute', FirmwareApplicationId);
    molten.addPlugin('Attribute', FirmwareApplication);
    molten.addPlugin('Attribute', Id);
    molten.addPlugin('Attribute', Metadata);
    molten.addPlugin('Attribute', Name);
    molten.addPlugin('Attribute', ProjectId);
    molten.addPlugin('Attribute', StartTime);
    molten.addPlugin('Attribute', State);
    molten.addPlugin('Attribute', Type);
    molten.addPlugin('Attribute', UpgradeOptions);
    molten.addPlugin('Attribute', LoadBalancerEnabled);
    molten.addPlugin('Attribute', UpgradeWindowsEnabled);
    molten.addPlugin('Attribute', DeviceGroups);
    molten.addPlugin('Attribute', PercentToGetApplication);
  }
};